<template>
  <div class="salesman-form-jobNumber">
    <loading :isShow="loading" />
    <Form ref="form" :model="formData" :label-width="80" class="page-form" :show-message="false">
      <FormItem label="工号类型" class="full" v-if="$units.superviseShowVal()">
        <RadioGroup v-model="type" @on-change="radioChange">
          <Radio label="1">保险公司</Radio>
          <Radio label="2">合作通道</Radio>
        </RadioGroup>
        <div class="btn-box">
          <Button class="save-btn" type="warning" @click="add">新增</Button>
          <Button class="save-btn" type="primary" @click="importData" ghost>批量导入</Button>
          <Button class="save-btn" type="primary" @click="daochu" ghost>导出</Button>
        </div>
      </FormItem>
      <div class="btn-box" v-else>
        <!-- <Button class="save-btn" type="warning" @click="add">新增</Button> -->
      </div>
      <FormItem label="业务员姓名">
        {{ baseInfo.name }}
      </FormItem>
      <FormItem label="所属机构">
        {{ baseInfo.organizationName }}
      </FormItem>
      <no-data v-if="tableData.length === 0"></no-data>
      <div class="table-box" v-else>
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click="updateStatus(row, 1)" v-if="row.bjsSyncStatus == 0">上号</span>
            <span class="table-btn" @click="updateStatus(row, 0)" v-if="row.bjsSyncStatus == 1">下号</span>
            <span class="table-btn" @click="edit(row)">编辑</span>
            <span class="table-btn red" @click="delOne(row)">删除</span>
          </template>
        </Table>
      </div>
    </Form>

    <!-- 新增/编辑 -->
    <above-personnel-form ref="abovePersonnelForm" @reload="getList" :hasMgaProduct="true" />
    <!-- 导入 -->
    <importTool ref="importTool" @success="setData()"></importTool>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal"></confirm-modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import importTool from '@/components/commons/importTool/index2';
import abovePersonnelForm from '@/pages/offline/insuranceManage/components/abovePersonnelForm';
import { config } from './jobNumber.config.js';
export default {
  mixins: [config],
  components: {
    abovePersonnelForm,
    confirmModal,
    importTool
  },
  props: {},
  data() {
    return {
      baseInfo: {},
      loading: false,
      type: '1',
      tableData: [],
      formData: {
        type: '1'
      },
      columns: [],
      userId: ''
    };
  },
  computed: {},
  mounted() {
    this.userId = this.$route.query.userId;
  },
  methods: {
    // 修改上号状态
    updateStatus(item, bjsSyncStatus) {
      const data = JSON.parse(JSON.stringify(item));
      data.bjsSyncStatus = bjsSyncStatus;
      this.loading = true;
      this.$http({
        url: '/buz/userStaff/updateBjsSync',
        type: 'POST',
        data: data
      })
        .then(res => {
          this.loading = false;
          this.$notice.msg('操作成功');
          this.getList();
        })
        .catch(e => {
          window.setTimeout(() => {
            this.loading = false;
          }, 300);
        });
    },
    // 删除
    delOne(row) {
      if (row.bjsSyncStatus == 0) {
        this.delAjax(row);
        return;
      }
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否要删除此业务员，删除后业务员此工号将会自动下号'
        })
        .then(() => {
          this.delAjax(row);
        });
    },
    // 发送删除请求
    delAjax(row) {
      this.$http({
        url: '/buz/userStaff/del',
        type: 'GET',
        data: {
          id: row.id
        }
      }).then(res => {
        this.$notice.success('删除成功');
        this.getList();
      });
    },
    // 导出
    daochu() {
      this.loading = true;
      this.$http({
        url: '/buz/userStaff/export',
        type: 'POST',
        responseType: 'blob',
        data: {
          userId: this.userId
        }
      })
        .then(res => {
          this.$units.daochu(res);
        })
        .finally(() => {
          window.setTimeout(() => {
            this.loading = false;
          }, 300);
        });
    },
    // 导入
    importData() {
      const dic = JSON.parse(localStorage.dic)['USER_STAFF_EXPORT'];
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        params: {},
        uploadParams: {
          userId: this.userId
        },
        template: key,
        templateName: dic[key],
        uploadUrl: '/buz/userStaff/batch/upload',
        errorUrl: '/buz/userStaff/exportError'
      });
    },
    setData(baseInfo) {
      this.baseInfo = baseInfo;
      this.getList();
    },
    // 获取列表数据
    getList() {
      if (!this.userId) {
        //新增不执行
        return;
      }
      this.getColumns();
      this.loading = true;
      this.$http({
        url: '/buz/userStaff/read/list',
        type: 'post',
        data: {
          userId: this.userId
        }
      })
        .then(res => {
          this.loading = false;
          if (res.data && res.data.length) {
            this.tableData = res.data;
          } else {
            this.tableData = [];
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 切换工号类型
    radioChange() {
      this.formData.type = this.type;
      this.getList();
    },
    add() {
      this.$refs.abovePersonnelForm.open(
        {
          userId: this.userId,
          staffType: this.type,
          orgName: this.baseInfo.organizationName,
          groupName: this.baseInfo.groupName
        },
        'userAdd'
      );
    },
    edit(row) {
      this.$refs.abovePersonnelForm.open({
        ...row,
        orgName: this.baseInfo.organizationName,
        groupName: this.baseInfo.groupName
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './jobNumber.scss';
</style>
